













































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { Constants } from '@/constants/constants';
import { email, required } from 'vuelidate/lib/validators';
import { BreadCrumbElement } from '@/models/bread-crumb-element';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GTitleBar from '@/components/GTitleBar.vue';
import { activityModule } from '@/store/modules/entities/activity.module';
import { Activity } from '@/models/activity/activity';
import { ActivityItemCategory } from '@/models/activity/activity';
import { CreateActivityParam } from '@/models/activity/activity';
import GLoading from '@/components/GLoading.vue';
import GOptionalIcon from '@/components/GOptionalIcon.vue';
import GVTag from '@/components/GVTag.vue';

@Component({
  name: 'GJgrowActivityCreate',
  components: {
    GLoading,
    GTitleBar,
    GCustomBreadCrumb,
    GOptionalIcon,
    GVTag,
  },
  computed: {},
  methods: {},
  validations: {
    createActivityName: { required },
  },
})
export default class GJgrowActivityCreate extends mixins(GPageBase) {
  breadCrumbItems: BreadCrumbElement[] = [];
  listColumn: object[] = [];
  lazy: boolean = false;
  processing: boolean = false;
  size: number = 24;
  activityName: string;

  async mounted() {
    await activityModule.fetchActivities();
    await activityModule.fetchCategoriesWithItem();
    this.$v.createActivityName.$touch();

    this.breadCrumbItems = [
      {
        title: this.$t('HOME').toString(),
        icon: 'ios-home',
        routerPath: '/pages/home',
      },
      { title: 'アクティビティ設定' },
    ];
    this.lazy = true;
  }

  /**
   * 新規作成実行
   */
  handleCommit() {
    this.processing = true;
    if (this.isValid()) {
      activityModule.createActivity().then(() => {
        this.showInsertSuccessed();
        setTimeout(() => {
          this.$router.push(`/pages/jgrow/activity`);
        }, 2000);
      });
    } else {
      this.processing = false;
    }
  }

  get isProcessing(): boolean {
    return this.processing;
  }

  get activities() {
    return activityModule.activities;
  }

  get activityCategories() {
    return activityModule.activityItemCategories;
  }

  get createActivityName() {
    return activityModule.createActivityName;
  }

  set createActivityName(val: string) {
    activityModule.setCreateActivityName(val);
  }

  get isActivityNameInvalid(): boolean {
    return this.$v.createActivityName.$dirty && this.$v.createActivityName.$invalid;
  }

  get isActivityItemCategoryInvalid(): boolean {
    const selected = this.activityCategories.filter((category: ActivityItemCategory) => {
      return category.selectedItems.length;
    });
    return selected.length === 0;
  }

  isValid(): boolean {
    this.$v.createActivityName.$touch();
    return !this.isActivityNameInvalid && !this.isActivityItemCategoryInvalid;
  }
}
